.LoadingSpinner {
  animation: loading-spinner-rotate 1.28973s linear infinite;
  transform-origin: center center;
  height: 1rem;
  width: 1rem;

  circle {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: loading-spinner-dash 2s ease-in-out infinite;
    stroke-linecap: round;
    stroke-width: 4px;
  }
}

@keyframes loading-spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
